<template>
    <div>
        <div class="card" v-loading="loading">
            <div class="header">用户登录</div>
            <div class="card-txt">
                <el-form :model="model" :rules="rules" ref="loginForm">
                    <el-form-item label="" prop="userName" class="m-t-20">
                        <el-input v-model="model.userName" placeholder="昵称 \ 手机号 \ 邮箱"></el-input>
                    </el-form-item>
                    <el-form-item label="" prop="password">
                        <el-input v-model="model.password" type="password" maxlength="32" placeholder="密码"></el-input>
                    </el-form-item>
                </el-form>
                <!--<div class="row"><input type="text" v-model="model.userName" placeholder="昵称\手机号\邮箱"></div>
                <div class="row"><input type="password" v-model="model.password" placeholder="密码"></div>-->
                <div class="forgetPwd">忘记密码？请联系管理员重置</div>
                <div class="btn">
                    <router-link to="/register">还不是澳尚会员？请先注册</router-link>
                    <button @click="login">登录</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import shopCart from '@/js/mixins/shopCart.js'
    export default {
        name: 'buyerLogin',
        mixins: [shopCart],
        data () {
            return {
                loading: false,
                model: {
                    userName: '',
                    password: '',
                    /*          userName: '',
                              password: '',*/
                },
                rules: {
                    userName: [
                        { required: true, message: '请输入手机号、昵称或邮箱', trigger: 'blur' },
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { min: 6, max: 32, message: '请输入6-32位密码', trigger: 'blur' }
                    ],
                },
                isCanEnterKey: true
            }
        },
        created () {
            try {
                this.enterKeyup();
            } catch(e) {
                console.log("enter keyup error")
            }
        },
        methods: {
            login () {
                var that = this;
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.$axios.post(window.consts.apis.login, this.model).then(res => {
                            this.loading = false
                            if (res.success) {
                                localStorage.setItem(window.consts.strings.userToken, res.result.accessToken)
                                //登录成功获取信息
                                this.axios.get(window.consts.apis.getMyInfo).then(r=>{
                                    if(r.success && r.result && r.result.id>0){
                                        this.$store.dispatch('setUser', {
                                            id: r.result.id,
                                            uid: r.result.name,
                                            mobile: r.result.phoneNumber,
                                            email: '',
                                            lastLogin: ''
                                        })
                                    }
                                })
                                this.$store.dispatch('setUser', {
                                    id: res.result.userId,
                                    uid: '',
                                    mobile: '',
                                    email: '',
                                    lastLogin: ''
                                })
                                this.$notify({
                                    title: '登录成功',
                                    message: '请开始您的购物之旅吧！',
                                    type: 'success',
                                    duration: 2000
                                })
                                let q = this.$route.query
                                if (q && q.returnUrl && q.returnUrl.indexOf("/login") < 0) {
                                    this.$router.replace({ path: q.returnUrl })
                                } else {
                                    this.$router.replace('/')
                                }
                                that.getShopCartList(() => {
                                    
                                });
                            } else {
                                this.isCanEnterKey = false;
                                this.$alert(res.error.details, '', {
                                    callback: (action) => {
                                        setTimeout(() => {
                                            this.isCanEnterKey = true;
                                        }, 1000);
                                    }
                                })
                            }
                        })
                        /*.catch(res => {
                        this.$alert('登录出现异常错误，请与管理员联系', '')
                    })*/
                    }
                })
            },
            getShopCartList (callback) {
                this.$axios.get(window.consts.apis.getShoppingCartList, { params: { Page: 1, Size: 100} }).then(res => {
                    if (res.success) {
                        this.syncShopCart(res.result.items, callback);
                    } else {
                        callback();
                    }
                }).catch(e => {
                    callback();
                })
            },
            enterKey(event) {
                const code = event.keyCode
                    ? event.keyCode
                    : event.which
                        ? event.which
                        : event.charCode;
                if (code == 13 && this.isCanEnterKey) {
                    this.login();
                }
            },
            enterKeyup() {
                document.addEventListener("keyup", this.enterKey);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card {
        width: 600px;
        margin: 70px auto;
        box-shadow: 0 0 10px #ddd;

        .header {
            font-size: 18px;
            padding: 20px 30px;
            border-bottom: 1px solid #eee;
        }

        .card-txt {
            padding: 20px 30px;

            .row {
                padding-top: 20px;

                input {
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    padding-left: 10px;
                    box-sizing: padding-box;
                    border: none;
                    border-bottom: 1px solid #eee;
                    font-size: 16px;
                    outline: none;
                    color: #666;
                }
            }

            ::v-deep .el-form-item {
                margin-bottom: 30px;
            }

            ::v-deep .el-input__inner {
                height: 44px;
                line-height: 44px;
            }

            .forgetPwd {
                margin-top: -10px;
                color: #888;
            }

            .btn {
                text-align: right;
                padding: 30px 0 10px 0;

                button {
                    width: 120px;
                    height: 44px;
                    line-height: 44px;
                    background: #90ca6f;
                    color: white;
                    margin-left: 20px;
                }

                a {
                    color: #666;
                    text-decoration: underline;
                }
            }
        }
    }

</style>
